"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _MediaButton = _interopRequireDefault(require("./MediaButton"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row"
  }
}));

const MediaButtonbar = ({
  buttons,
  onAdd,
  onUpload
}) => {
  const classes = useStyles();

  if (!buttons) {
    return false;
  }

  return _react.default.createElement("nav", {
    className: classes.root
  }, buttons.map((button, index) => {
    return _react.default.createElement(_MediaButton.default, _extends({}, button, {
      key: index
    }));
  }));
};

var _default = MediaButtonbar;
exports.default = _default;
module.exports = exports.default;